import React from 'react';
import DeleteModalStyle from './DeleteModalStyle';
import { Button } from 'src/components';

interface DeleteModalProps {
  isModalDeleteOpen: boolean;
  handleOk: () => void;
  handleCancel: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  isModalDeleteOpen,
  handleOk,
  handleCancel
}) => {
  return (
    <DeleteModalStyle
      title="Delete"
      visible={isModalDeleteOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      className="modal-delete"
    >
      <p className="text-content">Are you sure you want to delete this content?</p>
      <div className="button-footer">
        <Button buttonType="cancel" onClick={handleCancel} width={100}>
          No
        </Button>
        <Button htmlType="submit" onClick={handleOk} width={100}>
          Yes
        </Button>
      </div>
    </DeleteModalStyle>
  );
};

export default DeleteModal;
